<template>
    <app-modal modal-id="warehouse-modal" modal-size="default" modal-alignment="top" @close-modal="closeModal">
        <template slot="header">
            <h5 class="modal-title">
                {{ $t("add_warehouse_item_shop") }}
            </h5>
            <button type="button" class="close outline-none" data-dismiss="modal" aria-label="Close">
                <span>
                    <app-icon :name="'x'"></app-icon>
                </span>
            </button>
        </template>
        <template slot="body">
            <form ref="form" v-if="dataLoaded" :data-url="`crm/warehouse-items`">
                <div class="form-group mb-5">
                    <div class="row">
                        <div class="mb-0 col-sm-5 d-flex align-items-center">
                            <label>{{ $t("warehouse_type_list_shop") }}</label>
                        </div>
                        <div class="col-sm-7">
                            <app-input type="search-select" list-value-field="name" :list="warehouseTypeListItemShop"
                                :placeholder="$t('choose_an_warehouse_type_shop')" v-model="formData.type_id"
                                :error-message="$errorMessage(errors, 'warehouse_type_id')"/>
                        </div>
                    </div>
                </div>
                <div class="form-group mb-5">
                    <div class="row">
                        <div class="mb-0 col-sm-5 d-flex align-items-center">
                            <label>{{ $t("warehouse_qty") }}</label>
                        </div>
                        <div class="col-sm-7">
                            <app-input type="number" :placeholder="$t('enter_number_qty')" name="name"
                                v-model="formData.qty" :error-message="$errorMessage(errors, 'name')" />
                        </div>
                    </div>
                </div>
                <div class="form-group mb-5">
                    <div class="row">
                        <div class="mb-0 col-sm-5 d-flex align-items-center">
                            <label>{{ $t("price_sum") }}</label>
                        </div>
                        <div class="col-sm-7">
                            {{ numberWithCurrencyMuseum(price) }}
                        </div>
                    </div>
                </div>
            </form>
            <app-overlay-loader v-else />
        </template>
        <template slot="footer">
            <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal" @click.prevent="closeModal">
                {{ $t("cancel") }}
            </button>
            <button type="button" class="btn btn-primary" @click.prevent="submit">
                <span class="w-100">
                    <app-submit-button-loader v-if="loading"></app-submit-button-loader>
                </span>
                <template v-if="!loading">{{ $t("save") }}</template>
            </button>
        </template>
    </app-modal>
</template>
<script>

import { FormSubmitMixin } from "@app/Mixins/Global/FormSubmitMixin";
import { mapGetters } from "vuex";
import { collection, urlGenerator, numberWithCurrencyMuseum } from "@app/Helpers/helpers";

export default {
    name: "WarehouseModal",
    mixins: [FormSubmitMixin],
    props: {
        tableId: {
            type: String,
            required: true
        },
        pipelineId: {
            type: Number,
            required: true
        },
        selectedUrl: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            numberWithCurrencyMuseum,
            isOrganizationModalActive: false,
            addMoreDetails: false,
            dataLoaded: false,
            countryList: [],
            warehouse: '',

            type: 3,
            formData: {
                owner_id: user.id,
                qty: 1
            },
            addEditData: {},
            warehouseTypeListItemShop: [],
        };
    },
    computed: {
        ...mapGetters({

        }),

        price() {
    const selectedWarehouseType = this.warehouseTypeListItemShop.find(
      (type) => type.id === this.formData.type_id
    );

    if (selectedWarehouseType) {
        this.warehouse = selectedWarehouseType.id;
      return selectedWarehouseType.price * this.formData.qty;
    } else {
      return 0;
    }
  },


    },
    methods: {

        getShop() {
            //this.preLoader = true;
            this.axiosGet('/crm/shop/')
                .then((res) => {
                    this.warehouseTypeListItemShop = res.data;
                })
                .finally(() => {
                    this.dataLoaded = true;
                });
        },


        beforeSubmit() {
            this.loading = true;
        },
        submit() {
            this.addEditData.qty = this.formData.qty;
            this.addEditData.owner_id = this.formData.owner_id;
            this.addEditData.price = this.price;
            this.addEditData.warehouse_id = this.warehouse;
            this.addEditData.type_id = this.type;

            this.save(this.addEditData);
        },
        afterSuccessFromGetEditData(response) {
            this.formData = response.data;

        },

    },
    mounted() {

        this.getShop();
    },
    created() {

    }
};
</script>
